import { staticConfig } from "@fidget/common/config/static-config";
import { IChatItem, MessageWithFormChatItem, UserTextChatItem } from "@fidget/common/models/chat/chatItems";
import { findLast, takeRight } from "lodash";
import { RichMessage } from "../components/chat/richMessages/RichMessageTypes";
import { extractRichMessageFromContext } from "../components/chat/richMessages/utils";

export interface ChatInputBlocker {
  checkShouldBlockInput(items: IChatItem[]): boolean;
}

export class FormChatInputBlocker implements ChatInputBlocker {
  checkShouldBlockInput(items: IChatItem[]): boolean {
    return this.isFormInputBlock(items)
      || this.isDynamicFormInputBlock(items);
  }

  private isFormInputBlock(items: IChatItem[]): boolean {
    const item = findLast(
      takeRight(items, staticConfig.widgetPageSize),
      (chatItem) => MessageWithFormChatItem.isMessageWithFormChatItem(chatItem)
        || UserTextChatItem.isUserTextChatItem(chatItem));

    if (!item) {
      return false;
    }

    if (UserTextChatItem.isUserTextChatItem(item)) {
      return false;
    }

    if (!MessageWithFormChatItem.isMessageWithFormChatItem(item)) {
      return false;
    }

    if (item.submission.userInputs) {
      return false;
    }

    return item.submission.blockInputUntilSubmitted;
  }

  private isDynamicFormInputBlock(items: IChatItem[]): boolean {

    const item = findLast(
      takeRight(items, staticConfig.widgetPageSize),
      (chatItem) => UserTextChatItem.isUserTextChatItem(chatItem));

    if (!item) {
      return false;
    }

    if (!UserTextChatItem.isUserTextChatItem(item)) {
      return false;
    }

    const richMessage: RichMessage | undefined = extractRichMessageFromContext(item.context);

    if (!richMessage) {
      return false;
    }
    return !!richMessage.widgetBlockInput;
  }
}
